import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "../store/store";
import { LOGINPAGE } from "../views/auth/routes";
import { HOMEPAGE } from "../views/home/routes";
import { hasModuleFromToken, isAdminFromToken } from "../utils/authToken";
import { moduleForPath } from "../utils/accessModules";
import { isTokenValid } from "../utils/isTokenValid";

type Props = {
  children: React.ReactElement;
};

const AdminRoute: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  if (!rehydrated) return null;

  if (!isTokenValid(token) || !isAdminFromToken(token)) {
    return <Navigate to={LOGINPAGE()} replace />;
  }

  // Módulo retirado do administrador restrito (ADR 0027). O `StaffLayout` faz o
  // mesmo; aqui cobre as telas de admin montadas fora dele.
  const module = moduleForPath(pathname);
  if (module && !hasModuleFromToken(token, module)) {
    return <Navigate to={HOMEPAGE()} replace />;
  }

  return children;
};

export default AdminRoute;
